import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecf35464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-oc-coupon-list" }
const _hoisted_2 = { class: "page-title" }

import { onMounted, ref } from 'vue';
  import { request } from '@/utils';
  import CardCoupon from '../components/card-coupon.vue';
  import { ICoupon } from '@/types/coupon';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const coupons = ref<ICoupon[]>([]);
  const pageInited = ref(false);
  const route = useRoute();
  onMounted(async () => {
    const { data } = await request.get<ICoupon[]>('/oc_coupon_records', { params: Object.assign(route.query, { page: 0 }) });
    coupons.value = data;
    pageInited.value = true;
  });

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('My Coupon')), 1),
    (pageInited.value && coupons.value.length === 0)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(coupons.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "coupon"
          }, [
            _createVNode(CardCoupon, {
              class: "coupon",
              coupon: item
            }, null, 8, ["coupon"])
          ]))
        }), 128))
  ]))
}
}

})